import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BusinessGroupsComponent } from '@src/app/features/business-groups/business-groups/business-groups.component';
import { ViewBusinessGroupComponent } from '@app/features/business-groups/view-business-group/view-business-group.component';
import { EditBusinessGroupComponent } from '@src/app/features/business-groups/edit-business-group/edit-business-group.component';

const routes: Routes = [
  { path: '', component: BusinessGroupsComponent },
  { path: 'add', component: BusinessGroupsComponent },
  { path: ':businessGroupId/edit', component: EditBusinessGroupComponent },
  { path: ':businessGroupId', component: ViewBusinessGroupComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessGroupsRoutingModule { }
